"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormRadioButtonField = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _FormLabelField = require("../FormLabelField");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const FormRadioButtonField = (param)=>{
    let { id, label, radioButtonYes, radioButtonNo, required, disabled } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { control } = (0, _reactHookForm.useFormContext)();
    const renderRadioButton = (0, _react.useCallback)((param)=>{
        let { field, fieldState } = param;
        var _fieldState_error_message, _fieldState_error;
        const hasError = !!fieldState.error;
        const helperText = (_fieldState_error = fieldState.error) === null || _fieldState_error === void 0 ? void 0 : (_fieldState_error_message = _fieldState_error.message) === null || _fieldState_error_message === void 0 ? void 0 : _fieldState_error_message.toString();
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.FormControl, {
            error: hasError,
            required: required,
            "data-testid": getTestId(_constants.FORM_RADIO_BUTTON_FIELD),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormLabelField.FormLabelField, {
                    label: label,
                    required: required
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.RadioGroup, {
                    ...field,
                    row: true,
                    id: id,
                    "data-testid": id,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.FormControlLabel, {
                            value: radioButtonYes,
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Radio, {}),
                            disabled: disabled,
                            label: radioButtonYes
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.FormControlLabel, {
                            value: radioButtonNo,
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Radio, {}),
                            disabled: disabled,
                            label: radioButtonNo
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.FormHelperText, {
                    children: helperText
                })
            ]
        });
    }, [
        required,
        getTestId,
        label,
        id,
        radioButtonYes,
        disabled,
        radioButtonNo
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
        name: id,
        control: control,
        render: renderRadioButton
    });
};
exports.FormRadioButtonField = FormRadioButtonField;
